<template>
  <td>{{ description }}</td>
</template>

<script>
  export default {
    name: "TablePlayerInsuranceLabel",
    props: ['description'],
  }
</script>

<style scoped>
  td {
    text-align: center !important;
  }
</style>

